export default "__VITE_ASSET__BTva6AgW__"